import {
  ACTION_TYPE_INCLUDE_RETURN_LABEL_WITH_OUTBOUND,
  ACTION_TYPE_INSURE_PACKAGE,
} from '../../pages/settings/automation-rules/constants/action-types';

export const SYSTEM_RULE_NAMES = {
  INCLUDE_RETURN_LABEL: 'Include return label with every shipment',
  INSURE_BY_RULES: 'Insure packages by order rules',
};

export const SYSTEM_RULE_CONFIGS = {
  [SYSTEM_RULE_NAMES.INCLUDE_RETURN_LABEL]: {
    actionTypeId: ACTION_TYPE_INCLUDE_RETURN_LABEL_WITH_OUTBOUND,
    filterId: null, // No filterId means no conditions - applies to all orders
    defaultParameter: { labelProviderId: 0, serviceId: 0, packageId: 0 }, // Default parameter object with labelProviderId, serviceId, and packageId
  },
  [SYSTEM_RULE_NAMES.INSURE_BY_RULES]: {
    actionTypeId: ACTION_TYPE_INSURE_PACKAGE,
    filterId: null,
    defaultParameter: null,
  },
};
